module.exports = __webpack_public_path__ + "img/Zmarta.867ac0ba.png";